import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from "@aspnet/signalr"

export default class HubCaseService {
	private caseConnectionShouldBeOpen: boolean = false;
	private caseConnection: HubConnection | null = null;

	public async openConnection (caseId: string): Promise<HubConnection> {
		if (this.caseConnection) {
			console.log("Leaving event")

			this.caseConnection.invoke("leaveCase", caseId)
			this.caseConnection.stop()
			this.caseConnection = null
		}

		console.log("Joining event ")
		const caseConnection = new HubConnectionBuilder()
			.withUrl(`${process.env.VUE_APP_HTTP_API_URI}case-hub`)
			.configureLogging(LogLevel.Information)
			.build()

		let startedPromise = null
		const start: () => Promise<any> = () => {
			if (!this.caseConnectionShouldBeOpen || !caseConnection || caseConnection.state !== HubConnectionState.Disconnected) {
				return Promise.resolve()
			}

			startedPromise = caseConnection.start()
				.then(() => {
					caseConnection.invoke("joinCase", caseId)
				})
				.catch(err => {
					console.error("HubCaseService - failed to connect with hub:", err)

					return new Promise((resolve, reject) =>
						setTimeout(() => start()
							.then(resolve)
							.catch(reject),
						5000))
				})
			return startedPromise
		}
		caseConnection.onclose(() => {
			if (this.caseConnectionShouldBeOpen) {
				console.log("Reconnecting due to close")
				start()
			}
		})

		this.caseConnectionShouldBeOpen = true
		await start()
		this.caseConnection = caseConnection

		return this.caseConnection
	}

	public closeConnection () {
		if (this.caseConnection) {
			this.caseConnectionShouldBeOpen = false
			console.log("Leaving event")

			this.caseConnection.stop()
			this.caseConnection = null
		}
	}

	public async inProgressUpdate (caseId: string, fieldId: string, value: string) : Promise<void> {
		if (this.caseConnection && this.caseConnection.state === HubConnectionState.Connected) {
			await this.caseConnection.invoke("setInProgress", caseId, fieldId, value)
		}
	}
}
